import { useState, useEffect } from 'react'
import moment from 'moment'
import queryString from 'query-string'

import { ClientJS } from 'clientjs'
import dayjs from 'dayjs'
import history from 'history'
import { getEnvParam, getTempEnvParam } from 'env'

import { getUMKFromLocal, setUMKToLocal } from 'pUtils'

export const DEFAULT_PAGE = '/records/all'
export const DEFAULT_AUTH_PAGE = '/auth/login'

const client = new ClientJS()

export function isVerificationEmail() {
  const inviteType = JSON.parse(getEnvParam('inviteType') || '{}')
  const verificationEmail =
    getTempEnvParam('verification_email') || getEnvParam('common_auth_changePW')
  const email = verificationEmail || inviteType.invitee_email

  if (email == null) {
    history.push(DEFAULT_AUTH_PAGE)
  }
}

export const popstateHandler = {
  handlePopState: null,

  didMount() {
    window.history.pushState(null, '', window.location.href)

    this.handlePopState = () => {
      window.history.pushState(null, '', window.location.href)
    }

    window.addEventListener('popstate', this.handlePopState)
  },

  unMount() {
    if (this.handlePopState) {
      window.removeEventListener('popstate', this.handlePopState)
      this.handlePopState = null
    }
  },
}

export function timeFormat(time, formatStr) {
  if (time == null || time.length === 0) {
    return null
  }

  let utcTime = time
  if (
    time.length != null &&
    // time.indexOf('T') > 0 &&
    time.indexOf('Z') === -1 &&
    time.indexOf('+') === -1
  ) {
    utcTime = `${time}Z`
  }
  return moment(utcTime).format(formatStr)
}

export const calculateRemainingDays = (expiresAt) => {
  if (!expiresAt) {
    return 0
  }
  // 백엔드가 timezone 없이 ISO를 보내는 경우 UTC로 보정. T 이후의 +/- offset(예: -07:00)은 유지.
  let utcStr = expiresAt
  if (typeof utcStr === 'string') {
    const tIndex = utcStr.indexOf('T')
    const hasOffset =
      utcStr.indexOf('Z') !== -1 ||
      utcStr.indexOf('+') !== -1 ||
      (tIndex !== -1 && utcStr.indexOf('-', tIndex) !== -1)
    if (!hasOffset) {
      utcStr = `${utcStr}Z`
    }
  }
  const expiredAt = dayjs(utcStr)
  const now = dayjs()
  // dayjs.diff()는 기본 절단 → 14일짜리 trial이 1초 경과 시 즉시 13일로 떨어지는 문제 방지.
  // float diff + Math.ceil로 "생성 직후 14일, 24시간 후 13일" 동작을 보장.
  const diffDays = Math.ceil(expiredAt.diff(now, 'day', true))
  return diffDays > 0 ? diffDays : 0
}

export function timeFormatDefault(time, defaultStr) {
  if (time == null || time.length === 0) {
    return defaultStr || '-'
  }

  let utcTime = time
  if (
    time.length != null &&
    // time.indexOf('T') > 0 &&
    time.indexOf('Z') === -1 &&
    time.indexOf('+') === -1
  ) {
    utcTime = `${time}Z`
  }

  return `${timeFormat(utcTime, 'l')} ${timeFormat(utcTime, 'LT')}`
}

export function timeFormatUTC(time, formatStr) {
  if (time == null || time.length === 0) {
    return '-'
  }

  let utcTime = time
  if (
    time.length != null &&
    // time.indexOf('T') > 0 &&
    time.indexOf('Z') === -1 &&
    time.indexOf('+') === -1
  ) {
    utcTime = `${time}Z`
  }
  return moment(utcTime).utc().format(formatStr)
}

export function timeFormatUTCDefault(time, defaultStr) {
  if (time == null || time.length === 0) {
    return defaultStr || '-'
  }

  let utcTime = time
  // if (time.length != null && time.indexOf('T') > 0 && time.indexOf('Z') === -1) {
  if (time.length != null && time.indexOf('Z') === -1) {
    utcTime = `${time}Z`
  }

  return `${timeFormatUTC(utcTime, 'l')} ${timeFormatUTC(utcTime, 'LT')}`
}

export function emailAddress(emailStr) {
  if (emailStr) {
    const pos = emailStr.indexOf('@')
    if (pos >= 0) {
      return {
        user: emailStr.substring(0, pos),
        host: emailStr.substring(pos + 1),
        address: emailStr,
      }
    }
  }
  return null
}

// export function localeDateTime(num) {
//   if (num != null) {
//     const time = new Date(num)
//     return time.toLocaleString()
//   }
//   return ''
// }

export function compareStr(a, b) {
  // if (a > b) {
  //   return 1
  // }
  // if (a < b) {
  //   return -1
  // }
  // return 0
  const aStr = a || ''
  const bStr = b || ''
  return aStr.localeCompare(bStr)
}

export function getSearchParams() {
  const parsed = queryString.parse(window.location.search, { parseNumbers: true })
  return parsed
}

export function setSearchParams(params, inherit) {
  if (params == null) {
    return
  }

  // let url = window.location.origin + window.location.pathname

  const prevParams = getSearchParams()

  let newParams = {
    ...params,
  }

  if (inherit !== false) {
    newParams = {
      ...prevParams,
      ...params,
    }
  }

  let isChanged = false
  const prevCount = Object.keys(prevParams).length
  const newCount = Object.keys(newParams).length
  if (prevCount !== newCount) {
    isChanged = true
  } else {
    Object.entries(newParams).forEach(([key, value]) => {
      if (isChanged === false && prevParams[key] !== params[key]) {
        isChanged = true
      }
      if (value === undefined) {
        delete newParams[key]
      }

      if (value == null || value === '') {
        delete newParams[key]
      }
    })
  }

  if (isChanged === true) {
    const urlData = {
      pathname: window.location.pathname,
    }

    const search = queryString.stringify(newParams)
    if (search != null && search.length > 0) {
      // url += `?${search}`
      urlData.search = `?${search}`
    }

    urlData.state = {
      replaceUrl: true,
    }

    // history.push(url)
    history.push(urlData, { replace: true })
  }
}

const paramInfo = {
  paramProps: {},
  lastSearchStr: null,
}
const paramChangeListeners = []

export function parseSearchParam() {
  paramInfo.paramProps = getSearchParams()
}

export function decodeFilterMap(nfilterStr) {
  const nfilter = {}
  const entries = nfilterStr.split(';')
  entries.forEach((str) => {
    if (str.length > 0) {
      const entry = str.split(':')
      if (entry.length > 1 && entry[1].length > 0) {
        const idxList = entry[1].split(',')
        const arr = []
        idxList.forEach((idx) => {
          arr.push(idx)
        })
        nfilter[entry[0]] = arr
      }
    }
  })
  return nfilter
}

export function encodeSortMap(sortMap) {
  let sortStr = ''
  Object.entries(sortMap).forEach(([key, value]) => {
    sortStr += `${key}:${value ? '1' : '0'};`
  })

  return sortStr
}

export function decodeSortMap(nsortStr) {
  const nsort = {}
  const entries = nsortStr.split(';')
  entries.forEach((str) => {
    if (str.length > 0) {
      const entry = str.split(':')
      if (entry.length > 1 && entry[1].length > 0) {
        nsort[entry[0]] = entry[1] === '1'
      }
    }
  })

  return nsort
}

export function encodeNSearch(searchFilters) {
  // return JSON.stringify(searchFilters);

  // value, value.value는 null이 될 수 없다. null 인 경우는 itemKey를 통해 전달됨.
  let searchStr = ''
  Object.entries(searchFilters).forEach(([key, value]) => {
    if (typeof value === 'string') {
      searchStr += `${key.length}I0I0I${value.length}I${key}III${value}I`
    } else {
      const val = typeof value.value === 'string' ? value.value : String(value.value)
      const filter = value.filter != null ? value.filter : ''
      searchStr += `${key.length}I${value.pKey.length}I${filter.length}I${val.length}I${key}I${value.pKey}I${filter}I${val}I`
    }
  })

  return searchStr
}

export function decodeNSearch(nsearchStr) {
  // return JSON.parse(nsearchStr)

  const nsearch = {}
  let pos = 0
  let ppos = 0
  const len = []
  const str = []
  let i
  let tmp

  while (nsearchStr.indexOf('I', ppos) > -1) {
    for (i = 0; i < 4; i += 1) {
      pos = nsearchStr.indexOf('I', ppos)
      if (pos < 0) {
        throw new Error('nsearch param error1.')
      }
      tmp = nsearchStr.substring(ppos, pos)
      ppos = pos + 1
      len[i] = parseInt(tmp, 10)
    }

    for (i = 0; i < 4; i += 1) {
      pos = ppos + len[i]
      if (pos > nsearchStr.length) {
        throw new Error('nsearch param error2.')
      }
      str[i] = nsearchStr.substring(ppos, pos)
      ppos = pos + 1
    }

    const [key, pKey, filter, value] = str
    if (pKey.length === 0) {
      nsearch[key] = value
    } else {
      nsearch[key] = {
        pKey,
        filter,
        value,
      }
    }
  }

  return nsearch
}

export function processNParam() {
  const sparams = paramInfo.paramProps

  if (sparams.nfilter != null) {
    const nfilterStr = decodeURIComponent(sparams.nfilter)

    const nfilter = decodeFilterMap(nfilterStr)

    if (Object.keys(nfilter).length > 0) {
      sparams.nfilter = nfilter
    } else {
      delete sparams.nfilter
    }
  }

  if (sparams.nsort != null) {
    const nsortStr = decodeURIComponent(sparams.nsort)

    const nsort = decodeSortMap(nsortStr)

    if (Object.keys(nsort).length > 0) {
      sparams.nsort = nsort
    } else {
      delete sparams.nsort
    }
  }

  if (sparams.nsearch != null) {
    let nsearch = decodeURIComponent(sparams.nsearch)
    nsearch = decodeNSearch(nsearch)

    if (Object.keys(nsearch).length > 0) {
      sparams.nsearch = nsearch
    } else {
      delete sparams.nsearch
    }
  }

  paramChangeListeners.forEach((func) => {
    func(paramInfo.paramProps)
  })
}

export function checkSearchParams() {
  if (paramInfo.lastSearchStr !== window.location.search) {
    paramInfo.lastSearchStr = window.location.search

    parseSearchParam()
    processNParam()
  }
}

export function getSearchParamProps() {
  checkSearchParams()
  return paramInfo.paramProps
}

export function addParamChangeListener(func) {
  if (paramChangeListeners.indexOf(func) < 0) {
    paramChangeListeners.push(func)
  }
}

export function removeParamChangeListener(func) {
  const pos = paramChangeListeners.indexOf(func)
  if (pos >= 0) {
    paramChangeListeners.splice(pos, 1)
  }
}

export function checkPageReplace(location, prevLocation) {
  if (
    location.pathname === prevLocation.pathname &&
    location.search !== prevLocation.search &&
    (location.state == null || location.state.replaceUrl !== true)
  ) {
    return false
  }
  return true
}

export function getTotalPageCnt(total, pageSize) {
  let totalPage = Math.floor(total / pageSize)

  if (total > pageSize * totalPage) {
    totalPage += 1
  }

  return totalPage
}

// babel을 통해 locale 키를 뽑아내기 위해 사용.
export function i18Key(key) {
  return key
}

export function getTimeStr(t) {
  if (t <= 0) {
    return '00:00'
  }
  const minute = Math.floor(t / 60)
  const second = Math.floor(t % 60)
  const minStr = minute > 9 ? minute : `0${minute}`
  const secStr = second > 9 ? second : `0${second}`
  const str = `${minStr}:${secStr}`
  return str
}

export function parseJwt(token) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => {
        // eslint-disable-next-line prefer-template
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join(''),
  )

  return JSON.parse(jsonPayload)
}

// export function isElementInViewport(el) {

//   const rect = el.getBoundingClientRect()
//   return (
//     (rect.top <= 0 && rect.bottom >= 0) ||
//     (rect.bottom >= (window.innerHeight || document.documentElement.clientHeight) &&
//       rect.top <= (window.innerHeight || document.documentElement.clientHeight)) ||
//     (rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight))
//   )
// }

export function openURL(url, option) {
  return () => {
    // option - _blank - 원래 window와 같은 크기로 팝업 생성.
    // option - 'width=800,height=600' - 크기 지정.
    if (option == null) {
      window.open(url)
    } else {
      window.open(url, '', option)
    }
  }
}

export function processError(error, cbFunc) {
  let ret = false
  if (error.code != null || error.message != null) {
    cbFunc(error.code, error.message, error)
    ret = true
  } else if (error.errors || error.graphQLErrors) {
    const errors = error.errors || error.graphQLErrors
    errors.some((errItem) => {
      const code = errItem.extensions != null ? errItem.extensions.code : -1
      if (cbFunc(code, errItem.message, errItem) === true) {
        return true
      }
      return false
    })
    ret = true
  }
  return ret
}

export function formatBytes(bytes, decimals = 2) {
  // if (bytes === 0) return '0 Bytes';
  let ret = '-'
  try {
    if (bytes === 0) return '0'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    const num = window.parseFloat((bytes / k ** i).toFixed(dm))

    if (Number.isNaN(i) === false && num != null) {
      ret = `${num} ${sizes[i]}`
    }
  } catch {
    ret = '-'
  }

  return ret
}

export function processOpenedFile(
  file,
  onChange,
  onLoadDataURL,
  acceptedType,
  sizeLimit,
  onSizeError,
) {
  // console.log(file);

  if (acceptedType != null) {
    const acceptList = acceptedType.split(',')
    const fileType = file.type.toLowerCase()
    acceptList.some((item) => {
      let ret = false
      const checkType = item.toLowerCase().trim()
      if (checkType === '*' || checkType === '*/*') {
        ret = true
      } else if (checkType.indexOf('.') === 0 && fileType.length > checkType.length) {
        // 파일 확장자.
        const ext = fileType.substring(fileType.length - checkType.length)
        ret = ext === checkType
      } else if (checkType.indexOf('/') > 0) {
        // mimeType
        const pos = checkType.indexOf('/*')
        if (pos > 0 && fileType.substring(0, pos) === checkType.substring(0, pos)) {
          // 해당되는 모든 타입 ex) image/* 등..
          ret = true
        } else if (fileType === checkType) {
          ret = true
        }
      }

      return ret
    })
  }

  if (sizeLimit == null || file.size < sizeLimit) {
    // this.uploadPhoto(file, loadingFunc)
    if (onChange != null) {
      onChange(file)
    }
    if (onLoadDataURL != null) {
      const reader = new FileReader()

      reader.onload = () => {
        const url = reader.result
        onLoadDataURL(url, file)
      }

      reader.readAsDataURL(file)
    }
  } else if (onSizeError != null) {
    onSizeError(file.size, sizeLimit)
  }
}

export function openFile(
  onChange,
  onLoadDataURL,
  acceptedType,
  sizeLimit,
  onSizeError,
  isMultiple = false,
) {
  let input = document.querySelector(`#image-picker`)
  if (input == null) {
    input = document.createElement('input')
    input.id = 'image-picker'
    input.setAttribute('type', 'file')
    document.body.appendChild(input)

    input.addEventListener('change', (evt) => {
      const { files } = evt.target
      if (!files.length) return

      // ✅ 여러 개의 파일을 병렬 처리하도록 Promise.all 사용
      Promise.all(
        Array.from(files).map((file) =>
          processOpenedFile(
            file,
            input.openFileObj.onChange,
            input.openFileObj.onLoadDataURL,
            null,
            input.openFileObj.sizeLimit,
            input.openFileObj.onSizeError,
          ),
        ),
      ).then(() => {
        console.log('모든 파일 처리 완료!')
      })
    })
  }

  const openFileObj = {
    onChange,
    onLoadDataURL,
    acceptedType,
    sizeLimit,
    onSizeError,
  }

  input.openFileObj = openFileObj

  input.multiple = isMultiple

  if (acceptedType != null) {
    input.setAttribute('accept', openFileObj.acceptedType)
  }

  input.value = ''
  window.prevInput = input

  input.click()
}

export function getTextFromHTML(htmlStr, processNode) {
  if (htmlStr == null) {
    return ''
  }
  const emptyDiv = document.createElement('div')
  emptyDiv.className = 'temp-html-parser'
  emptyDiv.innerHTML = htmlStr.replace(/\r?\n/gm, '')
  if (processNode != null) {
    processNode(emptyDiv)
  }
  document.body.appendChild(emptyDiv)

  const previewInnerText = emptyDiv.innerText
  emptyDiv.remove()

  return previewInnerText
}

export function getTextWidth(text, fontSize) {
  if (text == null) {
    return 0
  }
  const emptyDiv = document.createElement('div')
  emptyDiv.className = 'temp-html-parser'
  const textSpan = document.createElement('span')
  textSpan.style.wordBreak = 'keep-all'
  textSpan.style.whiteSpace = 'nowrap'
  textSpan.style.fontSize = fontSize || '12px'
  emptyDiv.appendChild(textSpan)

  textSpan.innerText = text

  document.body.appendChild(emptyDiv)

  const width = textSpan.offsetWidth
  emptyDiv.remove()

  return width
}

// export function reactTextContent(elem) {
//   return innerText(elem)
// }

export function copyElement(element) {
  if (client.isFirefox() === true) {
    const doc = document
    let range
    let selection

    const node = element.cloneNode(true)

    const copyDiv = document.createElement('div')

    copyDiv.className = 'temp-html-copy'
    copyDiv.appendChild(node)

    document.body.appendChild(copyDiv)

    if (doc.body.createTextRange) {
      range = doc.body.createTextRange()
      range.moveToElementText(node)
      range.select()
    } else if (window.getSelection) {
      selection = window.getSelection()
      range = doc.createRange()
      range.selectNodeContents(node)
      selection.removeAllRanges()
      selection.addRange(range)
    }
    document.execCommand('copy')
    window.getSelection().removeAllRanges()

    document.body.removeChild(copyDiv)

    return
  }

  navigator.clipboard.write([
    new ClipboardItem({
      'text/plain': new Blob([element.innerText], { type: 'text/plain' }),
      'text/html': new Blob([element.innerHTML], { type: 'text/html' }),
    }),
  ])
}

export function compareFile(a, b) {
  if (a != null && b != null) {
    return (
      a.name === b.name &&
      a.size === b.size &&
      a.lastModified === b.lastModified &&
      a.type === b.type
    )
  }
  return a === b
}

// const uniqueKeyMap = {}

// export function getUniqueKey(name) {
//   if (uniqueKeyMap[name] == null) {
//     uniqueKeyMap[name] = {
//       lastTime: -1,
//       idx: 1,
//     }
//   }

//   const valMgr = uniqueKeyMap[name]

//   let keyStr = null
//   const curTime = Date.now()
//   if (valMgr.lastTime !== curTime) {
//     keyStr = `${curTime}`
//     valMgr.lastTime = curTime
//     valMgr.idx = 1
//   } else {
//     keyStr = `${curTime}_${valMgr.idx}`
//     valMgr.idx += 1
//   }

//   return keyStr
// }

// const newNamePattern = /^(.* )[(](\d+)[)]$/
// export function createNewName(name) {
//   let newName = name
//   const found = newName.match(newNamePattern)

//   if (found != null && found.length === 3) {
//     const idx = parseInt(found[2], 10) + 1
//     newName = `${found[1]}(${idx})`
//   } else {
//     newName = `${name.trimEnd()} (1)`
//   }

//   return newName
// }

export function scrollIntoViewIfNeeded(elem) {
  if (elem.scrollIntoViewIfNeeded != null) {
    elem.scrollIntoViewIfNeeded()
  } else {
    elem.scrollIntoView({ block: 'nearest' })
  }
}

export const getUserDisplayName = (email, orgChartData) => {
  if (orgChartData?.users) {
    const user = orgChartData.users.find((users) => users.data?.account === email)

    if (user) {
      const {
        family_name: familyName,
        given_name: givenName,
        display_name: displayName,
      } = user.data
      if (familyName && givenName) {
        return `${familyName} ${givenName}`
      }
      return displayName || email
    }
  }
  return null
}

export const getUserAvatar = (email, orgChartData) => {
  if (orgChartData?.users) {
    const user = orgChartData.users.find((users) => users.data?.account === email)
    if (user) {
      return user.data?.profile_photo_url
    }
  }
  return null
}

export const getUserID = (email, orgChartData) => {
  if (orgChartData?.users) {
    const user = orgChartData.users.find((users) => users.data?.account === email)

    if (user) {
      return user.data?.id
    }
  }
  return null
}

export const setPagination = (pageInfo) => {
  const params = getSearchParams()
  const limit = pageInfo.limit || 10
  // 현재 페이지에 항목이 1개뿐이었는데(offset 이 마지막 항목 인덱스와 일치) 그 항목을 삭제하면
  // 페이지가 비므로 한 페이지 앞으로 이동한다. 그 외에는 현재 페이지를 그대로 재조회.
  // (과거엔 페이지 크기를 10 으로 하드코딩해 limit≠10 이면 오작동했다.)
  const isNowEmptyLastPage =
    typeof params.page === 'number' &&
    params.page > 1 &&
    Math.floor(pageInfo.offset / limit) === Math.floor(pageInfo.total / limit) &&
    pageInfo.offset === pageInfo.total - 1
  const nextPage = isNowEmptyLastPage ? params.page - 1 : params.page
  setSearchParams({ page: nextPage })
  pageInfo.setPage(nextPage, false, true)
}

export const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= breakpoint)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [breakpoint])

  return isMobile
}

export const lockSafebox = async () => {
  const UMK = await getUMKFromLocal()

  setUMKToLocal(
    UMK,
    {
      duration: 1,
      loopTime: 1,
      warningDuration: 0,
    },
    false,
  )
}

const utils = {
  timeFormat,
  emailAddress,
  compareStr,
  getSearchParams,
  setSearchParams,
  getTotalPageCnt,
  i18Key,
  getTimeStr,
  formatBytes,
  openURL,
  getTextFromHTML,
  getTextWidth,
  // reactTextContent,
  copyElement,
  compareFile,
  // getUniqueKey,
  // createNewName,
  scrollIntoViewIfNeeded,
  getUserDisplayName,
  setPagination,
  useIsMobile,
}

export default utils
